export default __webpack_public_path__ + "static/media/Ring of the Excavator.4f57f1a8.jpg";